import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import { UTTouchableWithoutFeedback, UTLabel } from '@widergy/energy-ui';

import { trackEvent } from '../../../../../../../services/AnalyticsService';
import { categories, actions, labels } from '../../../../../../../constants/analytics';

import styles from './styles';

const EMAIL = 'email';
const PHONE = 'telefono';

const onMailPressed = () =>
  trackEvent(
    categories.DENUNCIAS,
    `${actions.ENVIAR_MAIL_DENUNCIA} ${EMAIL}`,
    labels.ENVIAR_MAIL_DENUNCIA_OK
  );

const onPhonePressed = () =>
  trackEvent(categories.DENUNCIAS, `${actions.LLAMAR_POR_DENUNCIA} ${PHONE}`, labels.LLAMAR_POR_DENUNCIA_OK);

function ContactItem({ contactItem, mail, phone }) {
  return (
    <div style={styles.container}>
      <img alt="" src={contactItem.iconUrl} style={styles.image} />
      <div style={styles.contactInfo}>
        {mail ? (
          <UTTouchableWithoutFeedback transparent onPress={onMailPressed} style={styles.button}>
            <a href={`mailto: ${mail}`} target="_blank" rel="noopener noreferrer" style={styles.link}>
              <UTLabel semibold white>
                {contactItem.contactInfo}
              </UTLabel>
            </a>
          </UTTouchableWithoutFeedback>
        ) : phone ? (
          <UTTouchableWithoutFeedback transparent onPress={onPhonePressed} style={styles.button}>
            <a href={`tel: ${phone}`} target="_blank" rel="noopener noreferrer" style={styles.link}>
              <UTLabel semibold white style={styles.mobileText}>
                {contactItem.contactInfo}
              </UTLabel>
            </a>
          </UTTouchableWithoutFeedback>
        ) : (
          <UTLabel semibold white>
            {contactItem.contactInfo}
          </UTLabel>
        )}
      </div>
    </div>
  );
}

ContactItem.propTypes = {
  mail: PropTypes.string,
  phone: PropTypes.string,
  contactItem: PropTypes.any.isRequired // eslint-disable-line react/forbid-prop-types
};

export default Radium(ContactItem);
